import { GridService } from '../shared/grid/grid.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Control } from '../models/control.model';

@Injectable({
    providedIn: 'root'
})
export class ControlService extends GridService<Control> {

    constructor(http: HttpClient) {
        super('Control', http);
    }
}
